const useWithCookiesConsent =
  (callback: (consent?: string[]) => void): (() => void) =>
  () => {
    let retry: ReturnType<typeof setInterval>;
    const initCookiesConsent = () => {
      if (window.OneTrust?.IsAlertBoxClosedAndValid()) {
        clearInterval(retry);
        const consent = window.OnetrustActiveGroups.split(',').filter((group) => group !== '');
        callback(consent);
      }
    };
    retry = setInterval(() => {
      initCookiesConsent();
    }, 2000);
  };

export default useWithCookiesConsent;
